
import { useEffect, useRef, useState } from 'react';
import '../styles/home.css';
import './home/home-reveal.css';
import './home/home-slots-carousel.css';
import AnimatedBackground from './ui/animated-background';
import HomeHero from './home/HomeHero';
import LiveWinsRail from './home/LiveWinsRail';
import ShowcaseRow from './home/ShowcaseRow';
import HomeSlotsRails from './home/HomeSlotsRails';
import HomeLiveCasinoRail from './home/HomeLiveCasinoRail';
import HomeMatchCarousel from './home/HomeMatchCarousel';
import PromotionsBlock from './home/PromotionsBlock';
import HomeProviders from './home/HomeProviders';
import { useAuth } from '../context';
import { useSiteContent } from '../context/SiteContentContext';
import { useIsMobile } from '../hooks/useIsMobile';
import { useHomeReveal } from '../hooks/useHomeReveal';

export default function HomePage({ onNavigate, onRegister, onWelcomeLanding, onPromoDetails }) {
  const { user } = useAuth();
  const isMobile = useIsMobile();
  const { loading: cmsLoading } = useSiteContent();
  const rootRef = useRef(null);
  const [phase, setPhase] = useState(0); // 0=hero only, 1=+jackpot, 2=+below
  useHomeReveal(rootRef);

  useEffect(() => {
    let cancelled = false;
    let t1 = 0;
    let t2 = 0;
    let idleId = 0;

    const arm = () => {
      // After CMS can paint slider/showcase, unlock jackpot then below-fold.
      t1 = window.setTimeout(() => {
        if (cancelled) return;
        setPhase(1);
        const goBelow = () => {
          if (cancelled) return;
          setPhase(2);
        };
        if (typeof window.requestIdleCallback === 'function') {
          idleId = window.requestIdleCallback(goBelow, { timeout: 500 });
        } else {
          t2 = window.setTimeout(goBelow, 120);
        }
      }, cmsLoading ? 0 : 40);
    };

    if (!cmsLoading) {
      arm();
    } else {
      // Safety: don't wait forever if CMS stalls
      t1 = window.setTimeout(() => {
        if (cancelled) return;
        setPhase(1);
        t2 = window.setTimeout(() => {
          if (!cancelled) setPhase(2);
        }, 160);
      }, 1200);
    }

    return () => {
      cancelled = true;
      window.clearTimeout(t1);
      window.clearTimeout(t2);
      if (idleId && typeof window.cancelIdleCallback === 'function') {
        window.cancelIdleCallback(idleId);
      }
    };
  }, [cmsLoading]);

  const showJackpot = phase >= 1;
  const showBelow = phase >= 2;

  return (
    <div className="home" ref={rootRef}>
      <AnimatedBackground />
      <div className="home-content home-content--hero" data-reveal="hero">
        <HomeHero
          onNavigate={onNavigate}
          onRegister={onRegister}
          onWelcomeLanding={onWelcomeLanding}
          onPromoDetails={onPromoDetails}
          afterBanner={isMobile ? <ShowcaseRow onNavigate={onNavigate} reveal={false} /> : null}
          showJackpot={showJackpot}
        />
        {!isMobile && showBelow ? (
          <div data-reveal-item>
            <LiveWinsRail onNavigate={onNavigate} />
          </div>
        ) : null}
      </div>
      <div className="home-content">
        {!isMobile && <ShowcaseRow onNavigate={onNavigate} />}
        {showBelow && isMobile ? (
          <div data-reveal="section">
            <div data-reveal-item>
              <LiveWinsRail onNavigate={onNavigate} />
            </div>
          </div>
        ) : null}
        {showBelow ? (
          <>
            <div data-reveal="section">
              <div data-reveal-item>
                <HomeSlotsRails
                  onNavigate={onNavigate}
                  insertAfterPopular={(
                    <div className="home-slots-rails__insert home-slots-rails__insert--live" data-reveal-item>
                      <HomeLiveCasinoRail onNavigate={onNavigate} />
                    </div>
                  )}
                />
              </div>
            </div>
            <div data-reveal="section">
              <div data-reveal-item>
                <HomeMatchCarousel onNavigate={onNavigate} />
              </div>
            </div>
            <div data-reveal="section">
              <div data-reveal-item>
                <HomeProviders onNavigate={onNavigate} />
              </div>
            </div>
            <div className="main-frame main-frame--promo" data-reveal="section">
              <div data-reveal-item>
                <PromotionsBlock onNavigate={onNavigate} onRegister={onRegister} />
              </div>
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
}
